export { default as PostcodePopUp } from './post-code-popup'
